import React from 'react';
import { PageHeader } from '../PageHeader';
import { ActivityFeed } from '../ActivityFeed';
import { RightRail } from '../RightRail';
export function FeedPage() {
  return <>
      <PageHeader title="Feed" subtitle="The latest from across the company." data-id="element-444" />
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_340px] gap-6" data-id="element-445">
        <div className="min-w-0 max-w-2xl w-full" data-id="element-446">
          <ActivityFeed data-id="element-447" />
        </div>
        <div className="hidden xl:block" data-id="element-448">
          <RightRail data-id="element-449" />
        </div>
      </div>
    </>;
}